import { render } from "./RedirectYouzanPage.vue?vue&type=template&id=0c546b06&scoped=true"
import script from "./RedirectYouzanPage.vue?vue&type=script&lang=js"
export * from "./RedirectYouzanPage.vue?vue&type=script&lang=js"

import "./RedirectYouzanPage.vue?vue&type=style&index=0&id=0c546b06&scoped=true&lang=css"

import exportComponent from "/Users/alvinpascasio/pjf-wine-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c546b06"]])

export default __exports__